import { v4 as uuidv4 } from 'uuid';
import { MovementFromRequestCreatorView } from './MovementFromRequestCreatorView';
import useLockingDocuments from '../../../../../components/lockDocuments/useLockingDocuments';
import { IdTableVariant } from '../../../../../@types/enumsGlobal';
import { useAppContext } from '../../../../../system/providers/appContextProvider';
import { LotDataProvider } from '../../../../../Services/DataProviders/LotDataProvider';
import MovementGridPluginSettings from '../../MovementGridPluginSettings';

export const MovementFromRequestCreatorTab = (
    idGlobal: string,
    variant?: GridStateType,
    parentCallback?: <T>(message: T) => void,
    data?: { requestId: string; mnemocode?: string }
): ITab => {
    const appContext = useAppContext();
    const lotDP = new LotDataProvider(appContext.coreApiService);
    const lockingDocuments = useLockingDocuments();
    const tabId = uuidv4();
    const titleTab = data?.mnemocode
        ? `Создание перемещения из заявки ${data.mnemocode}`
        : 'Создание перемещения из заявки';

    return {
        id: tabId,
        title: titleTab,
        plugin: 'movement_from_request_creator_plugin',
        mnemocode: data?.mnemocode,
        closeWarning: true,
        onTabClosed: () => {
            lotDP.deleteOnlineReserve(idGlobal, () => {});
            lockingDocuments.delete({
                idTable: IdTableVariant.Movement,
                idDocument: idGlobal,
            });
        },
        view: {
            content: (
                <MovementFromRequestCreatorView
                    idGlobal={idGlobal}
                    requestId={data?.requestId ?? ''}
                    variant={variant ?? 'create'}
                    createdCallback={parentCallback}
                    permission={MovementGridPluginSettings.permission as IPermission}
                />
            )
        }
    };
};
